var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1.48624C4.85026 1.48624 1.48624 4.85026 1.48624 9C1.48624 13.1497 4.85026 16.5138 9 16.5138C13.1497 16.5138 16.5138 13.1497 16.5138 9C16.5138 4.85026 13.1497 1.48624 9 1.48624ZM0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9ZM13.2411 5.99747C13.5313 6.28768 13.5313 6.75819 13.2411 7.0484L8.28693 12.0025C7.99673 12.2927 7.52621 12.2927 7.236 12.0025L4.75894 9.52546C4.46873 9.23526 4.46873 8.76474 4.75894 8.47453C5.04914 8.18433 5.51966 8.18433 5.80987 8.47453L7.76147 10.4261L12.1901 5.99747C12.4803 5.70726 12.9509 5.70726 13.2411 5.99747Z",
    fill: "#5CB85C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivate);
export default __webpack_public_path__ + "static/media/activate.49bdcdaa1ba83b7ca2225a2c1da488f1.svg";
export { ForwardRef as ReactComponent };